module.exports = __webpack_public_path__ + "img/10-analises-minhas-lista.79afe523.png";